import { ADMIN_BFF_URL } from "environment";
import { axiosInstance } from "./axios";

interface IChangePassword {
  userId: string;
  new_password: string;
  old_password?: string;
}

export const changePassword = ({ userId, ...body }: IChangePassword) =>
  axiosInstance.patch(
    ADMIN_BFF_URL + `/v1/users/change-password/${userId}`,
    body
  );
